import { useEffect, useMemo, useState } from "react"
import { STORAGE } from "../constants"
import { LocalStorageService } from "../services/LocalStorageService"

function useTokenApi() {

    const [session] = useState(LocalStorageService.get(STORAGE.SESSION))

    const tokenApi = useMemo(
      () => {
        return session?.token_api
      },
      [],
    )


    return {
        tokenApi
    }
}
export default useTokenApi